/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    var module = this;

    module.sliderSettingsObject = {
        squareCards: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            loop: true,
            speed: 500,
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            }
        },

        cards: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500
        },

        cardsGroup: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            breakpoints: {
                1280: {
                    slidesPerGroup: 4
                }
            }
        },

        oneCardAutoplay: { /* в начале страницы на Главной */
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 1,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true
            },
            speed: 500
        },

        oneCard: { /* Не используется */
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 1,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500
        },

        productCard: { /* страница продукта */
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 1,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            on: {
                init: function () {
                    var swiper = this;
                    var sliderName = this.$el[0].getAttribute("data-slider-name");
                    var params = this.params;
                    var disabledTabs = document.querySelectorAll(".js-disabled-tabs");

                    if (sliderName) {
                        itsoftApp.modules.slidersLibrary.sliders[sliderName] = swiper;
                    }

                    this.params.customButtonActive = this.$el[0].closest(".js-slider").querySelector(".js-custom-button.js-active");
                    this.params.customButtons = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-button");

                    setTimeout(function () {
                        params.hashNavigation = false;

                        if (disabledTabs.length > 0) {
                            Array.prototype.forEach.call(disabledTabs, function (disabledTabsItem) {
                                disabledTabsItem.classList.remove("js-disabled-tabs");
                            });
                        }

                        swiper.slides[0].classList.remove("js-disabled-slide");
                        swiper.slides[1].classList.remove("js-disabled-slide");
                    }, 1000);
                },
                slideChange: function () {
                    var swiper = this;
                    var params = this.params;

                    setTimeout(function () {
                        var activeIndex = swiper.activeIndex;
                        var currentSlide = swiper.slides[activeIndex];

                        if ("#" + currentSlide.getAttribute("data-hash") !== location.hash) {
                            itsoftApp.modules.toggleTabs.callback.goToHash(currentSlide.getAttribute("data-hash"), "slider");
                        }
                    }, 10);
                }
            }
        },

        gallery: { /* Галерея внутри модалки */
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            on: {
                init: function () {
                    var swiper = this;
                    itsoftApp.modules.slidersLibrary.sliders["gallerySlider"] = swiper;
                }
            },
            speed: 500
        },

        galleryAutoHeight: { /* Галерея внизу страницы на Главной */
            slidesPerView: "auto",
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            autoHeight: true,
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            freeModeMomentum: false,
            speed: 500
        },

        galleryAuto: { /* Галерея в начале страницы на Главной без навигации */
            simulateTouch: false,
            allowTouchMove: false,
            keyboard: {
                enabled: false
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true
            },
            speed: 500
        },

        carouselThumbs: { /* Миниматюрная карусель на странице Мероприятие*/
            watchOverflow: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slidesPerView: 4,
            spaceBetween: 16,
            on: {
                init: function () {
                    var swiper = this;
                    itsoftApp.modules.slidersLibrary.sliders["carouselThumbs"] = swiper;
                    var timelineTextEl = document.querySelector(".js-carousel-main");
                    timelineTextEl.classList.add("js-visible");
                    var sliderSettingsKey = timelineTextEl.getAttribute("data-slider-settings"); // получаем data-атрибут
                    var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига

                    if (sliderSettingsKey && sliderSettingsObject) {
                        var sliderSettings = (sliderSettingsObject[sliderSettingsKey])();

                        itsoftApp.modules.slidersLibrary.callback(timelineTextEl, sliderSettings);
                    }
                },

                resize: function () {
                    itsoftApp.modules.slidersLibrary.sliders["carouselThumbs"].destroy(false, true);
                    itsoftApp.modules.slidersLibrary.sliders["carouselThumbs"] = undefined;

                    itsoftApp.modules.slidersLibrary.sliders["carousel"].destroy(false, true);
                    itsoftApp.modules.slidersLibrary.sliders["carousel"] = undefined;

                    var timelineEl = document.querySelector(".js-carousel-thumbs");
                    var sliderSettingsKey = timelineEl.getAttribute("data-slider-settings"); // получаем data-атрибут
                    var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject;

                    if (sliderSettingsKey && sliderSettingsObject) {
                        itsoftApp.modules.slidersLibrary.callback(timelineEl, sliderSettingsObject[sliderSettingsKey]);
                    }
                }
            },
            breakpoints: {
                1280: {
                    spaceBetween: 32
                }
            }
        },

        carousel: function () { /* Карусель на странице Мероприятие */
            var defaultSettings = {
                simulateTouch: false,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                a11y: {
                    firstSlideMessage: "",
                    lastSlideMessage: ""
                },
                slidesPerView: 1,
                followFinger: false,
                pagination: {
                    type: "bullets",
                    el: ".swiper-pagination"
                },
                on: {
                    init: function () {
                        var swiper = this;
                        itsoftApp.modules.slidersLibrary.sliders["carousel"] = swiper;
                    }
                }
            }

            defaultSettings.thumbs = {
                swiper: itsoftApp.modules.slidersLibrary.sliders["carouselThumbs"]
            }

            return defaultSettings;
        },

        carouselTimeline: { /* Миниматюрный таймлайн на странице О компании*/
            watchOverflow: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slidesPerView: 3,
            spaceBetween: 44,
            runCallbacksOnInit: false,
            on: {
                init: function () {
                    var swiper = this;

                    itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"] = swiper;
                    var timelineTextEl = document.querySelector(".js-carousel-main");
                    timelineTextEl.classList.add("js-visible");
                    var sliderSettingsKey = timelineTextEl.getAttribute("data-slider-settings"); // получаем data-атрибут
                    var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига

                    if (sliderSettingsKey && sliderSettingsObject) {
                        var sliderSettings = (sliderSettingsObject[sliderSettingsKey])();

                        var navigation = document.querySelector(".js-history-nav");

                        if (navigation) {
                            var prevBtn = navigation.querySelector(".js-prev-btn");
                            var nextBtn = navigation.querySelector(".js-next-btn");

                            sliderSettings.navigation = {};
                            sliderSettings.navigation.prevEl = prevBtn;
                            sliderSettings.navigation.nextEl = nextBtn;
                        }

                        itsoftApp.modules.slidersLibrary.callback(timelineTextEl, sliderSettings);
                    }
                },

                resize: function () {
                    itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"].destroy(false, true);
                    itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"] = undefined;

                    itsoftApp.modules.slidersLibrary.sliders["carouselHistory"].destroy(false, true);
                    itsoftApp.modules.slidersLibrary.sliders["carouselHistory"] = undefined;

                    var timelineEl = document.querySelector(".js-carousel-thumbs");
                    var sliderSettingsKey = timelineEl.getAttribute("data-slider-settings"); // получаем data-атрибут
                    var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject;

                    if (sliderSettingsKey && sliderSettingsObject) {
                        itsoftApp.modules.slidersLibrary.callback(timelineEl, sliderSettingsObject[sliderSettingsKey]);
                    }
                }
            },

            breakpoints: {
                768: {
                    slidesPerView: "auto"
                }
            }
        },

        carouselHistory: function () { /* Карусель на странице О компании */
            var defaultSettings = {
                simulateTouch: false,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                a11y: {
                    firstSlideMessage: "",
                    lastSlideMessage: ""
                },
                slidesPerView: 1,
                followFinger: false,
                autoHeight: true,
                thumbs: {
                    autoScrollOffset: 0
                },
                lazy: {
                    loadOnTransitionStart: true,
                    loadPrevNext: true,
                    loadPrevNextAmount: 2
                },
                on: {
                    init: function () {
                        var swiper = this;
                        var el = this.el;
                        var slidesLength = el.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
                        this.params.sliderLength = slidesLength;
                        itsoftApp.modules.slidersLibrary.sliders["carouselHistory"] = swiper;
                    },

                    slideNextTransitionStart: function () {
                        if (this.realIndex === this.params.sliderLength - 1) {
                            itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"].el.classList.remove("swiper-container-blur-end");
                        } else if (this.realIndex === 1) {
                            itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"].el.classList.add("swiper-container-blur-start");
                        }
                    },

                    slidePrevTransitionStart: function () {
                        if (this.realIndex === 0) {
                            itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"].el.classList.remove("swiper-container-blur-start");
                        } else if (this.realIndex === this.params.sliderLength - 2) {
                            itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"].el.classList.add("swiper-container-blur-end");
                        }
                    },

                    lazyImageReady: function () {
                        var swiper = this;
                        swiper.updateAutoHeight();
                    }
                },
                breakpoints: {
                    768: {
                        thumbs: {
                            autoScrollOffset: 1
                        }
                    }
                }
            }

            defaultSettings.thumbs.swiper = itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"];

            defaultSettings.breakpoints[768].thumbs.swiper = itsoftApp.modules.slidersLibrary.sliders["carouselTimeline"];

            return defaultSettings;
        },
    };
});